import { MemoizedSelector, createSelector } from '@ngrx/store';
import { AlertType } from '../../../../../core/model';
import { StateWithAlerts } from '../alerts-state';
import { getAlertsState } from './feature.selector';

export const getAlertDismissalStateFactory = (
  type: AlertType,
  newMessageHash: string
): MemoizedSelector<StateWithAlerts, boolean> => {
  return createSelector(getAlertsState, (state) => {
    const dismissal = state.dismissals && state.dismissals[type];
    let isOutDated = false;

    if (newMessageHash && dismissal?.messageHash) {
      isOutDated = newMessageHash !== dismissal?.messageHash;
    } else if (!dismissal?.messageHash) {
      //messageHash is missing in localstorage for users which has already dismissed the alert, in that case we show the alert again
      isOutDated = true;
    }

    return (dismissal?.dismissed && !isOutDated) || false;
  });
};
